import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  getExternalUser: (url: string, cpRefNo: string, forceCheck: boolean): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/external-users/${cpRefNo}`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: forceCheck,
      },
    }),

  externalUsersQuickSearch: (
    url: string,
    cuRefNo: string,
    guiIScreenId: string,
    searchString: string,
    page: string,
    pageSize: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/external-users/quick-search`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
        requestType: 'autocomplete',
        cuRefNo: cuRefNo,
        guiIScreenId: guiIScreenId,
        searchString: searchString,
        page: page,
        pageSize: pageSize,
      },
    }),
};
